export const userNotificationTypeMap = {
  licenceUpdate: 1,
  newVersion: 2,
  licenseLockUpdate: 3,
  licenseAboutToBeExpired: 4,
};

export const notificationConfigByType = {
  licenseUpdate: {
    icon: 'message-notifications-license-update',
  },
  newVersion: {
    icon: 'message-notifications-new-version',
  },
  licenseLockUpdate: {
    icon: 'message-notifications-license-locked',
  },
  licenseAboutToBeExpired: {
    icon: 'message-notifications-license-about-tobe-expired',
  },
};

export const messagesStateOptions = {
  seen: 'seen',
  notSeen: 'not-seen',
};

export const mapUserNotificationsTypeByKey = {
  1: 'licenseUpdate',
  2: 'newVersion',
  3: 'licenseLockUpdate',
  4: 'licenseAboutToBeExpired',
};

Object.freeze(notificationConfigByType);
Object.freeze(userNotificationTypeMap);
Object.freeze(mapUserNotificationsTypeByKey);
Object.freeze(messagesStateOptions);
